export default __webpack_public_path__ + "media/images/facebook-social-fd7c35c96bdb16c2e8fb23fcaa392384.svg";